import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import _ from 'lodash'
import { Student } from '@app/models/users'
import Mark from './Marks'
import { Score } from '@app/constants'
import SVG from 'react-inlinesvg'
import arrowLeft from '@icons/arrow-left'
import AnalyticsManager, { PageEventsTypes } from '@app/analytics/manager'
import { mainRoundStartDate } from '@app/components/shared/StateLabel/Label'

const taskPath = (task, tour) => `/students/tours/${tour}/tasks/${task.id}`

const Actions = (task, tour) => {
  return (
    <div className="task__actions">
      <Link
        to={
          tour === 'main' ?
            `/students/tours/${tour}/tasks/${task.id}/answer` :
            taskPath(task, tour)
        }
        onClick={() => {
          AnalyticsManager.emitPageEvent(PageEventsTypes.OlympTaskRetryClick, { task_name: task.names.en });
        }}
        className="task__link task__edit">
      </Link>
    </div>
  )
}

const Task = ({ item, index, tour }) => {
  const { task, answer } = item
  const classes = classnames("task", { "task--with-answer": !!answer })
  return (
    <div className={classes}>
      { tour !== 'preparatory' && (<div className="task__spacer" />) }
      <div className="task__desc">
        <Link to={taskPath(task, tour)} className="task__anchor" onClick={() => {
          AnalyticsManager.emitPageEvent(PageEventsTypes.OlympTaskClick, { task_name: task.names.en });
        }}>
          <div className="task__num">{ index + 1 }</div>
          <div className="task__name">{ task.name }</div>
        </Link>
        <Mark tour={tour} answer={answer} />
      </div>
      <div className="task__spacer task__actions-wrapper">
        { answer ? Actions(task, tour) : null }
      </div>
    </div>
  )
}

function areAllTasksSolved(obj) {
  for (let key in obj) {
    const task = obj[key];

    if (!task.answer) {
      return false;
    }

    if (task.answer.score !== Score.max) {
      return false;
    }
  }

  return true;
}

const Tasks = (props) => {
  const { statistics, student, tour, className, event } = props

  const tasksInProgressHeader = <>
    Try these tasks before the Olympiad!<br/>
    You have unlimited tries.
  </>

  const tasksFinishedHeader = <>
    Great! Come back on&nbsp;{mainRoundStartDate(event)}&nbsp;for the Olympiad.
    Until then, explore more tasks in DinoLab!
  </>

  const isAllTasksSolved = areAllTasksSolved(statistics.objects);

  if (isAllTasksSolved) {
    AnalyticsManager.emitPageEvent(PageEventsTypes.OlympAllTasksSolvedAppear);
  }

  const header = isAllTasksSolved ? tasksFinishedHeader : tasksInProgressHeader;
  const objects = _.values(statistics.objects)
  return (
    <div style={{
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      {tour !== 'main' && (
        <div className="student-tasks-page__header">
          {header}
        </div>
      )}
      <div className={"tasks-list--" + tour}>
        <div className={classnames("tasks-list", `tasks-list--${className}`)}>
          {isAllTasksSolved && (
            <button onClick={() => {
              window.location.href = window.PLATFORM_URL + '/program/1';
            }} className="student-tasks-page__header-button">
              GO TO THE TASK <SVG src={arrowLeft} style={{ transform: 'rotate(180deg)' }}/>
            </button>)}
          {
            _.map(objects, (item, index) => {
              return (
                <Task key={item.task.id} index={index} item={item} tour={tour}/>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

Tasks.propTypes = {
  student: PropTypes.instanceOf(Student).isRequired,
  statistics: PropTypes.object.isRequired,
  tour: PropTypes.oneOf(['preparatory', 'trial', 'main']).isRequired
}

export default Tasks
